// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

import * as types from './actionTypes';

export function changeFormField(field, value) {
  return {
    type: types.GETPAID_CHANGE_FORM_FIELD,
    field,
    value,
  };
}

export function resetState() {
  return {
    type: types.GETPAID_RESET_STATE,
  };
}

export function validateMobile(payload) {
  return {
    type: types.GETPAID_VALIDATE_MOBILE,
    payload,
  };
}

export function validateEmail(payload) {
  return {
    type: types.GETPAID_VALIDATE_EMAIL,
    payload,
  };
}

export function validateFormFailed(payload) {
  return {
    type: types.GETPAID_VALIDATE_FORM_FAILED,
    payload,
  };
}

export function validateFormSuccess() {
  return {
    type: types.GETPAID_VALIDATE_FORM_SUCCESS,
  };
}

export function confirmOrderForBookshop(payload) {
  return {
    type: types.GETPAID_CONFIRM_ORDER_FOR_BOOKSHOP,
    payload,
  };
}

export function validateForm(payload) {
  return {
    type: types.GETPAID_VALIDATE_FORM,
    payload
  };
}

export function setDiscountCode(value, field) {
  return {
    type: types.SET_DISCOUNT_CODE,
    value,
    field,
  };
}

export function validateDiscountCode() {
  return {
    type: types.VALIDATE_DISCOUNT_CODE,
  };
}

export function validateDiscountCodeStatus(payload) {
  return {
    type: types.VALIDATE_DISCOUNT_CODE_STATUS,
    payload,
  };
}

export function resetDiscountCode() {
  return {
    type: types.RESET_DISCOUNT_CODE,
  };
}

export function setActiveDiscountCode(payload) {
  return {
    type: types.ACTIVE_DISCOUNT_CODE,
    payload
  };
}

export function resetActiveDiscountCode() {
  return {
    type: types.RESET_ACTIVE_DISCOUNT_CODE
  };
}
